module.exports = ".avatarImg{\n    max-height: 42px;\n    border-radius: 50%;\n}"